var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leaderboard__generating-loader"},[_c('h5',[_vm._v(_vm._s(_vm.$t('Starting tournament. Hold on for a while.')))]),_c('span',{staticClass:"loader"})])
}
var staticRenderFns = []

export { render, staticRenderFns }